import React from 'react';
import DOMPurify from 'dompurify';

const SafeHTML = ({ html, tag = 'div', ...props }) => {
  const cleanHTML = DOMPurify.sanitize(html, { ADD_ATTR: ['target'] });  return React.createElement(tag, { dangerouslySetInnerHTML: { __html: cleanHTML }, ...props });
};

export default SafeHTML;
